import { render, staticRenderFns } from "./ClubAdminAppSvg.vue?vue&type=template&id=2021656d&"
import script from "./ClubAdminAppSvg.vue?vue&type=script&lang=ts&"
export * from "./ClubAdminAppSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports